import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import TaxRateList from './TaxRateList';
import { TAX_RATE_SAVED, TAX_RATE_DELETED } from '../subscriptions';
import { useToast } from 'hooks/toasts/useToast';
import { useSubscription } from 'hooks/apollo';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { taxRatesStore } from './TaxRateListBrowser';
import { Add } from '@mui/icons-material';
import { ADMIN_TAX_RATES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const newRecord = {
  id: null,
  code: '',
  description: '',
  percent: 0,
  category: 0
};

const TaxRateListContainer = () => {
  const [t] = useTranslation();
  const addToast = useToast();
  const { store, addActions, update } = useListBrowserUtils(taxRatesStore);
  const canWrite = usePermission(ADMIN_TAX_RATES_WRITE);

  const onAdd = useCallback(() => {
    if (store.values?.[0]?.id !== null)
      update(prev => {
        return { ...prev, values: [{ ...newRecord }, ...prev.values] };
      });
  }, [store.values, update]);

  const onCancelNew = useCallback(() => {
    if (store.values?.[0]?.id === null)
      update(prev => {
        return { ...prev, values: [...prev.values].slice(1) };
      });
  }, [store.values, update]);

  useEffect(() => {
    addActions([
      {
        name: 'Add',
        label: t('TaxRate.AddNew'),
        icon: <Add />,
        handler: onAdd,
        disabled: !canWrite
      }
    ]);
  }, [canWrite, addActions, onAdd, t]);

  useSubscription(TAX_RATE_SAVED, {
    onData: ({ _, client }) => {
      addToast(t('TaxRate.SaveSucceeded'), 'success');
      if (store.values?.[0]?.id === null) {
        client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'taxRates' });
        client.cache.gc();
      }
    }
  });

  useSubscription(TAX_RATE_DELETED, {
    onData: ({ data: { data }, client }) => {
      addToast(t('TaxRate.DeleteSucceeded'), 'success');
      client.cache.evict({ id: `TaxRate:{"id":${data.id}}` });
      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'taxRates' });
      client.cache.gc();
    }
  });

  return <TaxRateList list={store.values} loading={store.loading} onCancelNew={onCancelNew} />;
};

export default TaxRateListContainer;
